import React from "react";
import EmptyState from "../../component/emptyState";

export default function BlankPage() {
  return (
    <div className="h-full justify-center xl:pl-[345px] xl:justify-start flex flex-row items-center">
      <EmptyState
        heading="No contacts yet"
        subHeading="Your contacts will appear here once uploaded "
        button="Import contacts via CSV"
        link="Single Entry"
        page="leads"
      />
    </div>
  );
}
